import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { ResponseData, ResponsePaging } from "../../nest-responses";
import { RequestAddNationalityDto, RequestUpdateNationalityDto, RequestDeleteNationalityDto } from "../dto/nationality.dto";

@Injectable()
export class NationalityApi {
  private service: string = '';
  private model: string = 'nationality';
  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  addNationality(payload: RequestAddNationalityDto) {
    const method: string = 'POST';
    const func: string = 'addNationality';
    const params = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  updateNationality(payload: RequestUpdateNationalityDto) {
    const method: string = 'POST';
    const func: string = 'updateNationality';
    const params = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  deleteNationality(payload: RequestDeleteNationalityDto) {
    const method: string = 'POST';
    const func: string = 'deleteNationality';
    const params = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  listNationality(queryParams: { page: number, limit: number }) {
    const method: string = 'POST';
    const func: string = 'listNationality';
    const params = {};
    const urlParams: any = queryParams;
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<any>>(method, url, params, urlParams, body);
  }

  oneNationality(queryParams: { param: string }) {
    const method: string = 'GET';
    const func: string = 'oneNationality';
    const params = {};
    const urlParams: any = queryParams;
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/nationality.api.ts